import "./styles.less";

import React, { useContext } from "react";

import { Radio, Select } from "antd";
import { useOperationType } from "./OperationType.hook";
import { ConfigStateContext } from "../../../Contexts/Configurations/context";
import { IC_Collapse } from "shared-components/Components/Collapse/web";
import ButtonGroup from "../ButtonGroup/web";
import { firstLetterToUppercase } from "src/utils/Functions";

const { Option } = Select;

const optsSeason = [
	{
		value: 0,
		title: "Buscar por Calendario"
	},
	{
		value: 1,
		title: "Buscar por Temporada"
	}
]

export const OperationType = ({ collapsable = false, home = false, filterChanged, show, ...props }) => {
	if (!show) return null;
	
	const { country_code, translations } = useContext(ConfigStateContext);
	const isCeee = country_code === "ce3";
	const {
		inputType,
		data: { options = [], value, onChange, customKey },
	} = useOperationType({
		labeled: props?.labeled ?? false,
		selectedValue: props?.selectedValue,
		inputType: props?.inputType,
		filterChanged: filterChanged,
	});
	const { showSeasonInput, handleChangeSeason } = props;
	let filter = null;

	const handleChange = value => {
		const res = options.filter(o => o.value === value);

		onChange(res[0]);
	};

	if (inputType === 'select') {
		filter = (
			<Select
				value={isCeee ? Number(showSeasonInput) : value}
				onChange={(e) => isCeee ? handleChangeSeason(!showSeasonInput) : handleChange(e)}
			>
				{isCeee
				? optsSeason.map((option, index) => (
					<Option key={`option-season-${index}`} value={option.value}>
						{option.title}
					</Option>
				))
				: options.map(o => (
					<Option key={`key_${o.value}_operationType`} value={o.value}>
						{o.text}
					</Option>
				))}
			</Select>
		)
	} else if (inputType === 'radioselect') {
		filter = (
			<Radio.Group onChange={e => handleChange(e.target.value)} value={value}>
				{options.map(o => (
					<Radio value={o.value} key={`key_buttons_${o.value}_operationType`}>{o.text}</Radio>
				))}
			</Radio.Group>
		)
	} else if (inputType === 'buttonGroup') {
		filter = (
			<>
				<ButtonGroup
					options={options.map(e=>{return {text: e.text, value: e.value}})}
					selected={[value]}
					allowMuliple={false}
					onChange={handleChange}
				/>

				<hr style={{width:"100%", border:'none', borderTop:'1px solid rgba(0,0,0,.06)', margin:'24px 0'}} />
			</>
		);
	} else {
		filter = (
			isCeee ?  (
				<Radio.Group
					defaultValue={Number(showSeasonInput)}
					buttonStyle="solid"
					optionType="button"
					onChange={() => handleChangeSeason(!showSeasonInput)}
				>
					{optsSeason.map((option, index) => (
						<Radio.Button key={`button-season-${index}`} value={option.value}>{option.title}</Radio.Button>
					))}
				</Radio.Group>
			) : (
				<Radio.Group
					onChange={e => handleChange(e.target.value)}
					optionType="button"
					buttonStyle={"solid"}
					value={value}>
					{options.map(o => (
						<Radio.Button
							key={`key_buttons_${o.value}_operationType`}
							value={o.value}>
							{o.text}
						</Radio.Button>
					))}
				</Radio.Group>
			)
		)
	}

	return (
		<div className="filter operation-type-filter">
			{collapsable
				? <IC_Collapse label={firstLetterToUppercase(translations.transacción)} isActive={!!value} startOpen={!value}>
					{filter}
				</IC_Collapse>
				: <>
					{inputType === "buttonGroup" && <h3 className="filter-title">{firstLetterToUppercase(translations.transacción)}</h3>}

					{filter}
				</>
			}
		</div>
	);
};
